var base = require('navbar/navbar');
import searchmenu from '../../../../resources/js/components/shared/searchmenu';
import userdropdown from '../../../../resources/js/components/shared/userdropdown';

Vue.component('spark-navbar', {
	computed: {
		accessSettings() {
			if (this.$store.state.dataloaded){
				if(this.iCan(['create', 'edit', 'delete'], 'Products'))
					return true;
				if(this.iCan(['create', 'edit', 'delete'], 'Customers'))
					return true;
				if(this.iCan(['view', 'create', 'edit', 'delete'], 'Price Types'))
				return true;
				if(this.iCan(['create', 'edit', 'delete'], 'Purchase Orders'))
				return true;
				if(this.iCan(['create', 'edit', 'delete'], 'Fields'))
					return true;
				if(this.iCan(['create', 'edit', 'delete'], 'Departments'))
					return true;
				if(this.iCan(['create', 'edit', 'delete'], 'Exports'))
					return true;
			}
			return false;
		},
		orderDepartments() {
			return this.$store.getters.orderDepartments;
		},
		purchaseOrderDepartments() {
			return this.$store.getters.purchaseOrderDepartments;
		}
	},
	components: {
		'os-searchmenu': searchmenu,
		'os-userdropdown': userdropdown
	},
    mixins: [base],
    props: [
        'notifications',
        'has-unread-announcements',
        'loading-notifications',
        'support_modal'
    ],
    data: function() {
        return {
			menuinstall: [{
				icon: 'text_fields',
				title: 'Order fields',
				onclick: () => {
					this.$store.dispatch('set', {
						name: 'activetab',
						value: 1
					});
				}
			},{
				icon: 'shopping_cart',
				title: 'Products',
				onclick: () => {
					this.$store.dispatch('set', {
						name: 'activetab',
						value: 2
					});
				}
			},{
				icon: 'group',
				title: 'Customers',
				onclick: () => {
					this.$store.dispatch('set', {
						name: 'activetab',
						value: 3
					});
				}
			},{
				icon: 'business',
				title: 'Departments',
				onclick: () => {
					this.$store.dispatch('set', {
						name: 'activetab',
						value: 4
					});
				}
			}],
			// menumain: [{
			// 	icon: 'home',
			// 	title: 'Home',
			// 	to: '/'
			// },{
			// 	icon: 'business',
			// 	title: 'Departments',
			// 	to: '/departments'
			// },{
			// 	icon: 'show_chart',
			// 	title: 'Reports',
			// 	to: 'reports'
			// },{
			// 	icon: 'settings',
			// 	title: 'Configuration',
			// 	to: '/config'
			// }],
            navigation_modal: null,
            notifications_modal: false
        };
    },
    methods:{
        showSupportForm: function(){
            Bus.$emit('showSupportForm');
        },
        showNotifications() {
            this.notifications_modal = !this.notifications_modal;
            Bus.$emit('showNotifications');
        },
        showNavigation() {
            this.navigation_modal = !this.navigation_modal;
        }
    }
});
